<template>
    <div class="notfound-container d-flex flex-column h-100">
        <section class="col-md-4 container">
            <div class="form-upgrade card">
                <div class="row">
                    <div class="col-md-12">
                        <div class="upgrade-heading">
                            <h2 class="py-3 heading">{{ popupTitle }}</h2>
                        </div>
                        <div class="upgrade-plan py-3">
                            <p>
                                {{ popupDescription }}
                            </p>
                            <div class="buttons">
                                <a @click="onClickUpgradeSubscription" class="btn btn-outline-light btn-lg "
                                    v-if="popupType === 'special_plan_package'">
                                    Upgrade Subscription
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "SpecialPlanPopup",
    components: {},
    data() {
        return {
            popupType: null,
            popupTitle: null,
            popupDescription: null,
            accountData: null
        };
    },

    created() {
        this.popupType = "special_plan_package"
        this.setPopupText();
    },
    beforeDestroy() {
        this.$store.commit("showPopup", false);
    },
    computed: {

    },

    methods: {
        getText(val) {
            return this.$store.state.globalconfigs[val];
        },


        onClickUpgradeSubscription() {
            this.$router.push("/packages");
        },


        gotoAppStore(type) {
            if (type == "google") {
                window.open(
                    "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
                    "_blank"
                );
            } else if (type == "apple") {
                window.open(
                    "https://apps.apple.com/gm/app/ibakatv/id1060646446",
                    "_blank"
                );
            }
        },
        setPopupText() {
            if (this.popupType === "special_plan_package") {
                this.popupTitle = "Upgrade Subscription";
                this.popupDescription =
                    "You are currently on Special Package. Kindly Cancel your current subscription and upgrade to basic package to enjoy Full Features.";
            }
        },
        init() {
            this.$store.commit("setLoader", true);
            this.$store.dispatch("account").then((res) => {
                if (res) {
                    this.accountData = res.response;

                }
                this.$store.commit("setLoader", false);
            });
        },
    },
};
</script>
<style scoped>
.container {
    align-items: center;
    padding-top: 15%;
}

.card {
    border-radius: 20px;
}

.buttons {
    display: flex !important;
    justify-content: center !important;
    padding-bottom: 30px;
    padding-top: 30px;
    color: aliceblue;
    font-size: 20px;
}

.upgrade-plan>p {
    padding-top: 0px;
    padding-bottom: 5px;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 20px;
    text-align: center;
    display: flex !important;
    justify-content: center !important;
    padding-left: 40px;
    padding-right: 40px;
}

.upgrade-heading {
    padding-top: 10px;
    display: flex !important;
    justify-content: center !important;
}

.heading {
    display: flex !important;
    justify-content: center !important;
}

.notfound-container {
    content: "";
    position: sticky;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    width: 100%;
    overflow: hidden;
    min-height: 100vh !important;
    z-index: 100;
    background-blend-mode: overlay;
    background-color: rgba(103, 159, 61, 0.88);
}

.screen-limit {
    background: #679f3d;
    color: #f1f2f2;
    text-align: center;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

#home {
    position: sticky;
}
</style>
